import {inject, Injectable} from '@angular/core';
import {Userrole} from "../../../shared/interfaces/user";
import {UserService} from "../../../services/user.service";
import {ApiService} from "../../../services/api.service";
import {ReportService} from "../../error-report/data-access/report.service";
import {MalfunctionStatus, Report} from "../../../shared/interfaces/report";
import {SolutionService} from "../../knowledge-database/data-access/solution.service";
import {KnowledgeBaseService} from "../../knowledge-database/data-access/knowledge-base.service";
import {Escalation, EscalationRow, EscalationStatus, EscalationUpdate} from "../escalation.model";
import {catchError, Observable, switchMap} from "rxjs";
import {EscalationLoggingService} from "./escalation-logging.service";


@Injectable({
  providedIn: 'root'
})
export class EscalationService {
  escalationLoggingService = inject(EscalationLoggingService);
  userService = inject(UserService);
  apiService = inject(ApiService);
  reportService = inject(ReportService);
  solutionService = inject(SolutionService);
  knowledgeBaseService = inject(KnowledgeBaseService);
  rolesToEscalateTo = [
    Userrole.Techniker,
    Userrole.Produktionsleiter,
    Userrole.Teamleiter
  ]

  getAvailableRoles(): Userrole[] {
    return this.rolesToEscalateTo.filter((role) =>
      role !== this.userService.userrole())
  }

  escalateReport(targetRole: Userrole, message: string): void {
    if (this.reportService.currentReport()!.status === MalfunctionStatus.ESCALATED) {
      // close active escalation and open a new one
      this.reportService.updateEscalation$.next({
        report: this.reportService.currentReport()!.id,
        status: EscalationStatus.COMPLETED
      })
    }
    // update report
    this.reportService.update$.next({
      properties: {
        status: MalfunctionStatus.ESCALATED,
        solution: this.solutionService.solution().id
      }
    })
    // save current report and create new escalation
    this.reportService.escalateReport$.next({
      targetRole, message, selectedValues: {
        productionLine: this.knowledgeBaseService.expandedNodes().productionLine!,
        workplace: this.knowledgeBaseService.expandedNodes().workplace!,
        category: this.knowledgeBaseService.expandedNodes().category!,
      }
    });
    // TODO: e-mail notification
  }

  updateEscalation(updateObject: EscalationUpdate) {
    this.apiService.updateEscalation({
      id: updateObject.escalation.id,
      assigned_to_user: updateObject.action === 'takeover'
        ? this.userService.user()!.id
        : updateObject.escalation.assigned_to_user,
      report: updateObject.report.id!,
      status: updateObject.action === 'accept' || updateObject.action === 'takeover'
        ? EscalationStatus.ACCEPTED
        : EscalationStatus.IN_PROGRESS,
    }).pipe(
      switchMap((escalation: Escalation) =>
        this.escalationLoggingService.logEscalation({
          id: escalation.id!,
          reportId: escalation.report!,
          assignedToUser: escalation.assigned_to_user ? escalation.assigned_to_user : null,
        }, this.escalationLoggingService.getLoggingEvent(updateObject.action))
      ),
      catchError(error => {
        console.error('Error updating item', error);
        throw error
      }),
    ).subscribe();
  }

  updateEscalationProcessingStatus(escalationId: string, statusMessage: string): Observable<EscalationRow> {
    return this.apiService.updateEscalation({
      id: escalationId,
      processing_status_notification: statusMessage
    })
  }
}
